import axios from "axios";
import { reportApiError } from "../utils/errorEvents";

/**
 * axiosClient
 * Configuración de Axios para la comunicación con el API Gateway.
 * Incluye interceptores para manejo de errores y se podrá extender con
 * encabezados de autenticación, tokens, etc.
 */
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  timeout: 20000,
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Obtén el token del almacenamiento local
    // console log de la ruta
    // console.log('ruta axios: ', config.url, 'method: ', config.method);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta
axiosClient.interceptors.response.use(
  (response) => {
    // Si la respuesta ya tiene la estructura esperada, devolverla tal como está
    if (response.data && typeof response.data === "object") {
      // console.log('response axios: ', response.data);
      return response.data;
    }
    // Si no, devolver la respuesta completa
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - session expired
    if (error.response?.status === 401) {
      console.warn(
        "axiosInterceptor: received 401 Unauthorized, invoking session expired handler"
      );
      // Call global handler if available (set by AuthContext)
      if (typeof window.__handleSessionExpired === "function") {
        window.__handleSessionExpired();
      }
    }
    reportApiError(error);
    console.error("Axios error:", error);
    return Promise.reject(error);
  }
);

export default axiosClient;
